import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

export default class extends Controller {
  static values = {
    options: Object
  }

  // １度だけ初期化
  initialize() {
    // デフォルトオプションを設定
    const defaultOptions = {
      searchEnabled: true, // 検索機能を有効にする
      searchChoices: true, // 選択肢の中から検索する
      // searchResultLimit: 5, // 検索結果の最大表示数
      // renderChoiceLimit: 4, // 一度に描画する選択肢の最大数
      // placeholder: true, // プレースホルダーを表示する
      placeholderValue: '選択してください', // プレースホルダーのテキスト
      searchPlaceholderValue: '検索...', // 検索ボックスのプレースホルダーテキスト
      noResultsText: '一致する選択肢がありません', // 検索結果がない場合のテキスト
      noChoicesText: '選択肢がありません', // 選択肢がない場合のテキスト
      itemSelectText: 'クリックして選択' // 選択肢を選ぶ際のテキスト
    };

    // カスタムオプションとマージ
    const options = { ...defaultOptions, ...this.optionsValue };
    new Choices(this.element, options);
  }
}
